module.exports = __webpack_public_path__ + "static/Charlie-badge-1321f0d194a6a2941ce85af98cd6bb4c.svg";